/* 
 	* 指令下发组件 
 	* 描述 配置IP端口 
 	* 创建时间：2017-05-3 
 	* 创建人：baixx 
*/
<template>
    <div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>IP</label>
			    <div class="col-sm-8">
			      <input type="text" class="form-control" v-model="IP"/>
			    </div>
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>Port</label>
			    <div class="col-sm-8">
			      <input type="text" class="form-control" v-model="Port"/>
			    </div>
		   </div>
		   <div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		</form>
    </div>	
</template>
<script>
	export default {
		name: "InsBKPort",
		data() {
			return {
				IP :"",            //IP
				Port:"",            //Port
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {
			resetInput(){
				this.alertMsg = ''
				this.IP = ''
				this.Port = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				let r1=/^(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])$/.test(this.IP);
				if(!r1){
					this.alertMsg='请输入正确的IP地址';
					return;
				}else{
					this.alertMsg=''
				};
				let r2=/^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/.test(this.Port);
				if(!r2){
					this.alertMsg='请输入正确的端口号';
					return;
				}else{
					this.alertMsg=''
				}
				let arr = ["SETPRM",'04',this.IP,this.Port]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
				
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsBKPort.vue?0b664fbf